import React from 'react';
const BackgroundDesktop = () => {
    return (React.createElement("div", { className: 'background-mobile-2', style: { boxSizing: "border-box", pointerEvents: "none" } },
        React.createElement("div", { style: {
                position: "absolute",
                zIndex: "-1",
                flexShrink: "0",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%) translate3d(0, 0, 0)",
                borderRadius: "776.954px",
                opacity: "0.15",
                backgroundColor: "#919bea",
                filter: "blur(107px)",
            } },
            React.createElement("svg", { width: "714", height: "776", viewBox: "0 0 1227 815", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("g", { opacity: "0.15", filter: "url(#filter0_f_39_6977)" },
                    React.createElement("ellipse", { cx: "357.235", cy: "388.477", rx: "357.235", ry: "388.477", transform: "matrix(0.98973 0.142947 -0.473445 0.880823 443.845 -102)", fill: "#919BEA" })),
                React.createElement("defs", null,
                    React.createElement("filter", { id: "filter0_f_39_6977", x: "0.863281", y: "-268.771", width: "1225.25", height: "1120.03", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                        React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                        React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                        React.createElement("feGaussianBlur", { stdDeviation: "107", result: "effect1_foregroundBlur_39_6977" }))))),
        React.createElement("div", { style: {
                position: "absolute",
                zIndex: "-1",
                flexShrink: "0",
                right: "10px",
                transform: "translate3d(0, 0, 0)",
                borderRadius: "609.5px",
                opacity: "0.15",
                backgroundColor: "#accef5",
                filter: "blur(107px)",
            } },
            React.createElement("svg", { width: "400", height: "523", viewBox: "0 0 722 755", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("g", { opacity: "0.15", filter: "url(#filter0_f_39_6978)" },
                    React.createElement("ellipse", { cx: "304.75", cy: "261.825", rx: "304.75", ry: "261.825", transform: "matrix(0.409814 -0.912169 0.685801 0.727789 129 290.967)", fill: "#ACCEF5" })),
                React.createElement("defs", null,
                    React.createElement("filter", { id: "filter0_f_39_6978", x: "0.708984", y: "-347.52", width: "865.484", height: "1102.11", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                        React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                        React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                        React.createElement("feGaussianBlur", { stdDeviation: "107", result: "effect1_foregroundBlur_39_6978" }))))),
        React.createElement("div", { style: {
                position: "absolute",
                zIndex: "-1",
                flexShrink: "0",
                left: "10px",
                transform: "translate3d(0, 0, 0)",
                borderRadius: "609.5px",
                opacity: "0.15",
                backgroundColor: "#accef5",
                filter: "blur(107px)",
            } },
            React.createElement("svg", { width: "400", height: "523px", viewBox: "0 0 542 815", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("g", { opacity: "0.15", filter: "url(#filter0_f_39_6979)" },
                    React.createElement("ellipse", { cx: "304.75", cy: "261.825", rx: "304.75", ry: "261.825", transform: "matrix(0.409814 -0.912169 0.685801 0.727789 -196 397.967)", fill: "#ACCEF5" })),
                React.createElement("defs", null,
                    React.createElement("filter", { id: "filter0_f_39_6979", x: "-324.291", y: "-240.52", width: "865.484", height: "1102.11", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                        React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                        React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                        React.createElement("feGaussianBlur", { stdDeviation: "107", result: "effect1_foregroundBlur_39_6979" })))))));
};
export default BackgroundDesktop;
